import React from "react";
import styles from "./Notifications.module.css";
import { TextComponent } from "../../components";
import { List } from "antd";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";

const Notifications = () => {
  const dummyNotifications = [
    {
      id: 1,
      message:
        "Task # 2134 has been approved from Supervisor!",
      isRead: false,
      time: "6m",
    },
    {
      id: 2,
      message:
        "Task # 2134 has been approved from Supervisor!",
      isRead: true,
      time: "10m",
    },
    {
      id: 3,
      message:
        "Task # 2134 has been approved from Supervisor!",
      isRead: false,
      time: "26m",
    },
    {
      id: 4,
      message:
        "Task # 2134 has been approved from Supervisor!",
      isRead: false,
      time: "6m",
    },
    {
      id: 5,
      message:
        "Task # 2134 has been approved from Supervisor!",
      isRead: true,
      time: "10m",
    },
    {
      id: 6,
      message:
        "Task # 2134 has been approved from Supervisor!",
      isRead: false,
      time: "26m",
    },
  ];
  return (
    <div className={styles.mainCont}>
      <HeaderComponent heading={"Notifications"} />
      <div className={styles.SubDiv}>
        <List
          dataSource={dummyNotifications}
          style={{ margin: "20px 0" }}
          renderItem={(item, index) => {
            return (
              <div className={styles.listItem}>
                   <TextComponent
                    style={{ fontFamily: "Urbanist-regular" }}
                    className={styles.notiMess}
                    text={item?.message}
                  />
                  <TextComponent
                    style={{ fontFamily: "Urbanist-regular" }}
                    className={styles.notiTime}
                    text={`${item?.time} ago`}
                  />
               </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default Notifications;
